import BoardShare from './BoardShare.component';

export default BoardShare;
